

































































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { setStorage } from "@common/utils";
import Menu from "@/zh-website/src/components/website/Menu.vue";
import BottomFoot from "@/zh-website/src/components/website/BottomFoot.vue";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
import { NewsService } from "@/zh-website/src/views/Content/service/newsService";
@Component({
  components: {
    Menu,
    BottomFoot,
    SideBar
  }
})
export default class NewsCenter extends Vue {
  radio = 1;
  page = 1;
  list: any = [];
  total = 0;
  days: any = [
    { select: "全部", number: 0, label: 1 },
    { select: 7, number: 0, label: 2 },
    { select: 30, number: 0, label: 3 },
    { select: 90, number: 0, label: 4 },
    { select: 180, number: 0, label: 5 },
    { select: 360, number: 0, label: 6 }
  ];
  url = "https://www.zj-huawei.com";
  urls = "/home/news/det/";
  mounted() {
    //调用接口获取
    this.getData("", 1);
  }

  //选择天数
  choiceDay(screen, num) {
    this.total = num;
    this.page = 1;
    this.handleCurrentChange(1);
  }
  //获取数据
  async getData(screen, page) {
    NewsService.getNewsList({
      pageNum: page,
      pageSize: 10,
      timeFrameCode: screen
    }).then((res: any) => {
      this.list = res.data.list;
      this.total = res.data.totalCount;
    });
    NewsService.getNewsNumber().then((res: any) => {
      this.days[0].number = res.data.allNum;
      this.days[1].number = res.data.lastSevenDays;
      this.days[2].number = res.data.lastThirtyDays;
      this.days[3].number = res.data.lastNinetyDays;
      this.days[4].number = res.data.lastHalfYear;
      this.days[5].number = res.data.lastYear;
    });
  }
  handleCurrentChange(index) {
    this.scrollToTop();
    this.getData(this.radio, index);
    this.page = index;
  }
  // clearSelect() {
  //   this.radio = 0;
  //   this.page = 1;
  //   this.getData("", 1);
  // }
  scrollToTop() {
    document.documentElement.scrollTop = document.body.scrollTop = 0;
  }
}
